import React from 'react';
import { useRenderCount } from '@honeycomb/data';
import { CmsContentPage } from './CmsContentPage';
export function HomePage({ getPage }) {
    useRenderCount('HomePage');
    return React.createElement(CmsContentPage, Object.assign({}, { getPage }));
}
